import { render } from "./BodyBuilderOfferSaveModal.vue?vue&type=template&id=bb672dce"
import script from "./BodyBuilderOfferSaveModal.vue?vue&type=script&lang=js"
export * from "./BodyBuilderOfferSaveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__